import { Card, CardBody, HStack, Spinner, Stack, Text, VStack } from "@chakra-ui/react";
import ExportReportMenu from "./ExportReportMenu";
import NoContentCard from "./NoContentCard";
import ReportActionsBar from "./ReportActionsBar";
import ReportContent from "./ReportContent";

const ReportResultsSection = ({
  analysis,
  execution,
  filters,
  getAdvancedReportInfo,
  isAnalysisOpen,
  isRTL,
  language,
  selectedReport,
  setCopied,
  showReport,
  t,
  texts,
  toast,
  toggleAnalysis,
  copied,
  isExporting,
}) => {
  if (!(showReport && execution.reportData)) {
    return <NoContentCard t={t} />;
  }

  return (
    <VStack spacing={4} align="stretch">
      <Card shadow="xl" border="2px solid" borderColor="blue.100">
        <CardBody p={{ base: 4, md: 5 }}>
          <VStack spacing={4} align="stretch">
            <Stack
              direction={{ base: "column", md: "row" }}
              justify="space-between"
              align={{ base: "stretch", md: "flex-start" }}
              spacing={3}
            >
              <VStack align="stretch" spacing={1}>
                <Text fontSize="2xl" fontWeight="bold" color="blue.700">
                  {getAdvancedReportInfo(selectedReport).name}
                </Text>
                {isExporting && (
                  <HStack spacing={2} color="blue.600">
                    <Spinner size="sm" />
                    <Text fontSize="sm">{t("reports.exporting", "جاري التصدير...")}</Text>
                  </HStack>
                )}
              </VStack>
              <ExportReportMenu
                OnExport={analysis.handleExport}
                language={language}
                t={t}
                isExporting={isExporting}
              />
            </Stack>
            <ReportContent
              aiAnalysis={execution.aiAnalysis}
              filters={filters}
              getAdvancedReportInfo={getAdvancedReportInfo}
              isAnalysisOpen={isAnalysisOpen}
              isRTL={isRTL}
              language={language}
              reportApiResponse={execution.reportApiResponse}
              reportData={execution.reportData}
              selectedReport={selectedReport}
              t={t}
              texts={texts}
            />
            {!execution.reportApiResponse?.aiServiceFailure ? (
              <ReportActionsBar
                aiAnalysis={execution.aiAnalysis}
                copied={copied}
                getAdvancedReportInfo={getAdvancedReportInfo}
                isAnalysisOpen={isAnalysisOpen}
                isExporting={isExporting}
                isRTL={isRTL}
                reportApiResponse={execution.reportApiResponse}
                reportData={execution.reportData}
                selectedReport={selectedReport}
                setCopied={setCopied}
                t={t}
                toast={toast}
                toggleAnalysis={toggleAnalysis}
              />
            ) : null}
          </VStack>
        </CardBody>
      </Card>
    </VStack>
  );
};

export default ReportResultsSection;
